<template>
  <img
    :fetchpriority="fetchPriority"
    :width="width"
    :height="height"
    :src="src"
    :alt="alt"
    :class="classes"
    :decoding="decoding"
    :loading="loading"
  />
</template>

<script setup lang="ts">
/** types */
import type { TImage } from '~/src/types/common'

withDefaults(defineProps<TImage>(), {
  fetchPriority: 'low',
  decoding: 'auto',
  loading: 'lazy',
  width: 'auto',
  height: 'auto',
})
</script>
